import api from './api'
import reducer from './reducers'

export default {
  name: 'webrtc',
  api,
  reducer
}
